import React from "react";
import { useTranslation } from "react-i18next";
import { makeStyles } from "@material-ui/core/styles";
import { colors } from "../../theme";
import Content from "./Content";
// import useStyles from "./styles";

const useStyles = makeStyles((theme) => ({
  strong: {
    fontSize: "18px",
    fontWeight: "bold",
    fontStretch: "normal",
    lineHeight: "1.7",
    letterSpacing: "-0.04px",
    color: colors.TEXT_PRIMARY,
  },
  text: {
    fontSize: "16px",
    fontWeight: "normal",
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: "1.7",
    letterSpacing: "-0.04px",
    color: colors.TEXT_PRIMARY,
  },
}));

export default function CodeOfConduct() {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <Content>
      <>
        <strong className={classes.strong}>{t("codeofconduct.codeofconduct")}</strong>
        <p className={classes.text}>{t("codeofconduct.codeofconduct_info")}</p>
      </>
      <>
        <strong className={classes.strong}>{t("codeofconduct.community")}</strong>
        <ul>
          <li className={classes.text}>
            {t("codeofconduct.community_firstItem")}
          </li>
          <li className={classes.text}>
            {t("codeofconduct.community_secondItem")}
          </li>
          <li className={classes.text}>
            {t("codeofconduct.community_thirdItem")}
          </li>
          <li className={classes.text}>
            {t("codeofconduct.community_fourthItem")}
          </li>
        </ul>
      </>
      <>
        <strong className={classes.strong}>{t("codeofconduct.discussion")}</strong>
        <ul>
          <li className={classes.text}>
            {t("codeofconduct.discussion_firstItem")}
          </li>
          <li className={classes.text}>
            {t("codeofconduct.discussion_secondItem")}
          </li>
          <li className={classes.text}>
            {t("codeofconduct.discussion_thirdItem")}
          </li>
          <li className={classes.text}>
            {t("codeofconduct.discussion_fourthItem")}
          </li>
          <li className={classes.text}>
            {t("codeofconduct.discussion_fifthItem")}
          </li>
        </ul>
      </>
    </Content>
  );
}
